import { apiFetch, apiJson } from './http';

export type CategoryRow = {
  name: string;
  sort_order?: number;
  deleted_at?: string | null;
  media_type?: string;
};

export type CategoryMediaType = 'channels' | 'movies' | 'series';

export async function fetchCategories(
  playlistId: string,
  opts?: { includeDeleted?: boolean; mediaType?: CategoryMediaType },
): Promise<CategoryRow[]> {
  const qs = new URLSearchParams({ playlist_id: playlistId });
  if (opts?.includeDeleted) qs.set('include_deleted', '1');
  if (opts?.mediaType) qs.set('media_type', opts.mediaType);
  const res = await apiFetch(`/api/categories/get.php?${qs.toString()}`);
  if (!res.ok) return [];
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}

export async function reorderCategories(
  playlistId: number,
  order: string[],
): Promise<{ success: boolean; message?: string }> {
  return apiJson('/api/categories/reorder.php', {
    method: 'POST',
    body: JSON.stringify({ playlist_id: playlistId, order }),
  });
}

export async function renameCategory(payload: {
  playlist_id: number;
  old_name: string;
  new_name: string;
}): Promise<{ success: boolean; message?: string }> {
  return apiJson('/api/categories/rename.php', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function createCategory(payload: {
  playlist_id: number;
  name: string;
  sort_order?: number;
  media_type?: CategoryMediaType;
}): Promise<{ success: boolean; message?: string }> {
  return apiJson('/api/categories/create.php', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function deleteCategory(payload: {
  playlist_id: number;
  name: string;
}): Promise<{ success: boolean; message?: string }> {
  return apiJson('/api/categories/delete.php', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function restoreCategory(payload: {
  playlist_id: number;
  name: string;
}): Promise<{ success: boolean; message?: string; channels_restored?: number }> {
  return apiJson('/api/categories/restore.php', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
